var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherSlider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7895 16H6.21053C5.68842 16 5.22526 15.9829 4.81263 15.9229C2.59789 15.6743 2 14.6114 2 11.7143V8.28571C2 5.38857 2.59789 4.32571 4.81263 4.07714C5.22526 4.01714 5.68842 4 6.21053 4H13.7895C14.3116 4 14.7747 4.01714 15.1874 4.07714C17.4021 4.32571 18 5.38857 18 8.28571V11.7143C18 14.6114 17.4021 15.6743 15.1874 15.9229C14.7747 15.9829 14.3116 16 13.7895 16Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19C6.72375 19 6.5 18.7763 6.5 18.5C6.5 18.2237 6.72375 18 7 18C7.27625 18 7.5 18.2237 7.5 18.5C7.5 18.7763 7.27625 19 7 19Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19C9.72375 19 9.5 18.7763 9.5 18.5C9.5 18.2237 9.72375 18 10 18C10.2763 18 10.5 18.2237 10.5 18.5C10.5 18.7763 10.2763 19 10 19Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19C12.7237 19 12.5 18.7763 12.5 18.5C12.5 18.2237 12.7237 18 13 18C13.2763 18 13.5 18.2237 13.5 18.5C13.5 18.7763 13.2763 19 13 19Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherSlider);
export default ForwardRef;